import { subDays, format, getHours } from 'date-fns';

const getCacheTime = () => {
  const now = new Date();
  const curHour = getHours(now);
  return format(curHour < 22 ? subDays(now, 1) : now, 'yyMMdd');
};

export default getCacheTime;
